export default __webpack_public_path__ + "cb64f686a4b292304a440f14b77bba8c.png";